var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_807",
  "data-name": "Path 807",
  d: "M20,0h0a20,20,0,0,1,0,40h0A20,20,0,0,1,20,0Z",
  fill: "#008c45"
});
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "facebook-logo",
  transform: "translate(17 13.564)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_27",
  "data-name": "Path 27",
  d: "M33.625,0,30.747,0c-3.234,0-5.323,2.144-5.323,5.462V7.981H22.53a.453.453,0,0,0-.453.453v3.649a.453.453,0,0,0,.453.453h2.894v9.208a.452.452,0,0,0,.453.453h3.776a.453.453,0,0,0,.453-.453V12.535h3.384a.452.452,0,0,0,.453-.453V8.434a.453.453,0,0,0-.453-.453H30.1V5.846c0-1.026.245-1.547,1.581-1.547h1.939a.453.453,0,0,0,.452-.453V.457A.453.453,0,0,0,33.625,0Z",
  transform: "translate(-25.077 -4.564)",
  fill: "#fff"
}));
function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_53",
    "data-name": "Group 53",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.9e5d509da87b6f7b23327d0a72599fc2.svg";
export { ForwardRef as ReactComponent };